import React, {Component} from 'react';

import Pagination from 'components/Pagination';

import 'sass/test.scss';

import {getCookie, setCookie} from 'utils/cookie';

class Test extends Component {
    constructor(props) {
        super(props);

        this.state = {debugEnabled: true};
    }

    componentDidMount() {
        let debugEnabled;
        let defaultValue = true;

        let cookie = getCookie('debug');
        if (typeof cookie === 'undefined') {
            debugEnabled = defaultValue;
        }
        else {
            debugEnabled = (cookie == 1);
        }

        this.setState({debugEnabled});
    }

    renderPagination() {
        return (
            <div className="testPagination">
                <Pagination currentPage={3} totalCount={150} itemsPerPage={30} urlFn={(n) => '/page/'+n}/>
            </div>
        );
    }

    setDebug(value) {
        let name = 'debug';

        if (value) {
            setCookie(name, 1, 2678400);
        } else {
            setCookie(name, 0, 2678400);
        }

        this.setState({debugEnabled: value});
    }

    render() {
        return (
            <div className="test" style={{marginTop: '100px'}}>
                <div className="debug">
                    Debug enabled: {this.state.debugEnabled ? 'yes' : 'no'}
                    {this.state.debugEnabled ? <button onClick={() => this.setDebug(false)}>disable</button> : <button onClick={() => this.setDebug(true)}>enable</button>}
                </div>

                {this.renderPagination()}
            </div>
        );
    }
}

export default Test;


// WEBPACK FOOTER //
// ./src/containers/Test.js